<template>
    <div class="">
        <HeaderAdmin />
        <AsideAdmin />
        <main id="content" role="main" class="main">
            <div class="content container-fluid">
          
                <router-view></router-view>

            </div>
            <FooterAdmin />
        </main>


    </div>
</template>

<script>
import AsideAdmin from './admin/Aside.vue';
import FooterAdmin from './admin/Footer.vue';
import HeaderAdmin from './admin/Header.vue';

export default {
    name: "AppLayoutAdmin",
    components: {
        HeaderAdmin,
        AsideAdmin,
        FooterAdmin,
    }
}
</script>